export const BNK_STMT_updateUserBankReducer = {
  BNK_STMT_updateUserBank: (state, action) => {
    state.userBank = action.payload;
  },
};
